<template>
  <div class="cour_content">
    <coursedetail></coursedetail>
    <div class="course_qr">
      <img src="../../assets/qr-img.png">
      <span>关注微信公众号：山东考证</span>
    </div>
  </div>
</template>

<script>
import coursedetail from "@/components/Course-detail";
export default {
  components: {
    coursedetail
  }
};
</script>

<style>
.cour_content {
  background-image: linear-gradient(180deg, #2d8cf0 30%, #023547 100%);
  margin: 20px 100px;
  border: 1px;

  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.course_qr {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  font-size: 20px;
  font-weight: bold;
}
.course_qr img {
  width: 60%;
}
.course_qr span {
  padding: 20px;
}
</style>
